/** @file Re-checks an edited mesh through attachment meshTopology, the one topology validator (W2-32). */
import type { Draft } from 'immer';
import type { Doc, MeshAtt } from '@pose2d/format/types';
import { meshTopology } from '../attachment/meshTopology';

/** VALIDATION at `uvs`/`vertices`/`triangles`/`hull`/`edges` (meshTopology's order and paths) when the edited mesh disagrees. */
export function checkMeshTopology(draft: Draft<Doc>, mesh: MeshAtt): void {
  const g = mesh.geometry;
  const image = draft.images[mesh.image];
  const edges = mesh.edges === undefined ? {} : { edges: mesh.edges };
  const vertices = g.kind === 'rigid' ? g.vertices : g.bindVertices;
  meshTopology({ uvs: mesh.uvs, triangles: mesh.triangles, hull: mesh.hull, vertices, ...edges }, { w: image?.w ?? 1, h: image?.h ?? 1 });
}
